export default "__VITE_ASSET__BZGYWpBU__"